import React from 'react';

import Quota from 'components/Tvendo/Quota/Quota/List';

export default function () {
  return <Quota />;
}